<template>
    <div>
        <div class="col-sm-12">
            <div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px"
                        >{{ $t('landingPage.settingPrize.titleLPforPrize') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="prizesForm.title"
                            :config.sync="configForm.configFieldTitle"
                            :disabled="!!prizesForm.title_image"
                            @change="handleShotCodeStyle"
                            @blur="handleValidateField(configForm.configFieldTitle)"
                        />
                        <div class="mt-3">
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                                <div class="col-sm-3">
                                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                                        <InputText
                                            style="max-width: 120px"
                                            :model.sync="prizesForm.size_title"
                                            :config.sync="configForm.configFieldSizeTitle"
                                            :disabled="!!prizesForm.title_image"
                                        />
                                        <span>px</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="prizesForm.color_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                            :disabled="!!prizesForm.title_image"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="prizesForm.color_title"
                                            :config="{
                                                error: false
                                            }"
                                            :disabled="!!prizesForm.title_image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="prizesForm.background_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                            :disabled="!!prizesForm.title_image"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="prizesForm.background_title"
                                            :config="{
                                                error: false
                                            }"
                                            :disabled="!!prizesForm.title_image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.imgTitleLPforPrize') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="prizesForm.title_image"
                            :id="`TitlePrizeImgLP`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('landingPage.noteImageBeautiful') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.background') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="prizesForm.background.image"
                            :id="`BackgroundImgLP`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('noteUploadMaxMB') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                        <div class="form-group row mt-2">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="prizesForm.background.color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="prizesForm.background.color"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <InputCheckBox
                                :model.sync="prizesForm.is_repeat"
                                :id="`check-repeat-background-prize_lp`"
                                :value="prizesForm.is_repeat"
                                :label="`repeat`"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.selectedStyle') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap" style="gap: 1rem">
                            <div v-for="item in listStylePrizes" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="prizesForm.style"
                                    :name="`prize_setting-style`"
                                    :id="`prize_setting-style-${item.id}`"
                                    :value="item"
                                    :label="item.name"
                                    @change="handleShotCodeStyle('select')"
                                />
                                <div class="mt-2" style="width: 100px; height: 80px">
                                    <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-5">
                    <div class="text-right mb-5">
                        <button type="button" class="btn btn-outline-success btn-sm rounded" @click="handleAddTitle()">
                            <i class="fa fa-plus"></i>
                            賞品タイトルを追加
                        </button>
                    </div>
                </div>

                <Draggable
                    :list="prizesForm.prizes"
                    ghost-class="ghost--eventPrize"
                    class="overflow-hidden"
                    @start="dragList = true"
                    @end="dragList = false"
                    @change="handleShotCodeStyle"
                >
                    <div v-for="(evt, k) in prizesForm.prizes" :key="`prize-${k}`" class="card p-2">
                        <div class="card-body position-relative border-bottom">
                            <div class="d-flex flex-row mt-3">
                                <div class="mr-3">
                                    <div class="d-flex align-items-center justify-content-center h-100">
                                        <InputCheckBox
                                            class="custom-switch"
                                            :model.sync="evt.status"
                                            :id="`prize-${k}`"
                                            :value="true"
                                            :label="``"
                                            @change="handleShotCodeStyle"
                                        />
                                    </div>
                                </div>
                                <div class="mr-3 col-sm-1" style="min-width: 120px">
                                    <img
                                        loading="lazy"
                                        :src="evt?.image?.path"
                                        :alt="evt?.image?.origin_name"
                                        class="img-fluid mx-auto d-block rounded h-100 w-100"
                                        style="object-fit: contain"
                                    />
                                </div>
                                <div>
                                    <div class="col-sm-12 p-0">
                                        <h4 v-b-tooltip.hover :title="evt.title">{{ truncateTextTable(evt.title, 50) ?? '' }}</h4>
                                    </div>
                                    <div class="col-sm-12 p-0">
                                        <a target="_blank" :href="evt.image?.path">{{ truncateTextTable(evt.image?.path, 300) ?? '' }} </a>
                                    </div>
                                    <div class="p-1" v-html="truncateTextTable(evt.detail, 500) ?? ''"></div>
                                </div>
                            </div>
                            <div class="position-absolute" style="top: 0; right: 0">
                                <button
                                    v-b-tooltip.hover="`${$t('btn.copy')}`"
                                    type="button"
                                    class="btn btn-outline-info btn-sm rounded-circle"
                                    style="width: 30px; height: 30px"
                                    @click="handleCopyTitle(evt)"
                                >
                                    <i class="fa fa-copy"></i>
                                </button>
                                <button
                                    v-b-tooltip.hover="`${$t('btn.edit')}`"
                                    type="button"
                                    class="btn btn-outline-warning btn-sm rounded-circle mx-3"
                                    style="width: 30px; height: 30px"
                                    @click="handleEditTitle(evt, k)"
                                >
                                    <i class="fa fa-edit"></i>
                                </button>
                                <button
                                    v-b-tooltip.hover="`${$t('btn.delete')}`"
                                    type="button"
                                    class="btn btn-outline-danger btn-sm rounded-circle"
                                    style="width: 30px; height: 30px"
                                    @click="handleDeleteTitle(k)"
                                >
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>

            <ModalActionTitle
                v-if="configModalActionTitle.model"
                :config="configModalActionTitle"
                :dataTitle="formTitle"
                @updateData="eventUpdateDataTitle"
                @addData="eventAddDataTitle"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { configModalActionPrize, configModalActionTitle, STATUS_TITLE_PRIZE } from './constants';
import { truncateText, tranferShortCode, getCurrentDateTimeFormatted } from '@/utils/format';
import { InputText, InputCheckBox, InputRadio } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { LIST_STYLE_PRIZE } from '../../styles';
import { onHandleChangeTemp, mapImageDefault } from '../../handlers';

import ModalActionTitle from './modal-action-title.vue';
import Draggable from 'vuedraggable';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import { cloneDeep } from 'lodash';

export default {
    name: 'SettingPrizeList',
    components: {
        ModalActionTitle,
        Draggable,
        InputText,
        UploadImageCommon,
        InputCheckBox,
        InputRadio
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage', 'idxRefreshCampaign'])
        })
    },
    data() {
        return {
            configModalActionPrize: configModalActionPrize,
            configModalActionTitle: configModalActionTitle,
            formTitle: null,
            dragList: false,
            isVisibleEditor: false,
            listStylePrizes: mapImageDefault(LIST_STYLE_PRIZE),
            prizesForm: cloneDeep(this.dataForm)
        };
    },

    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },

        isActiveModalEdit(idActive) {
            return idActive == this.configModalActionPrize.id;
        },

        handleAddTitle() {
            this.configModalActionTitle.title = this.$t('history.register');
            this.formTitle = {
                make_id: this.onHandleMakeId(),
                typeAction: 'Add',
                title: '',
                size_prize: '20',
                color_prize: '',
                background_prize: '',
                background_item: '',
                image: null,
                detail: '',
                number_of_winner: '',
                status: STATUS_TITLE_PRIZE[0].value,
                campaign_event_prize_id: null
            };
            this.configModalActionTitle.model = true;
        },

        onHandleMakeId() {
            const handleMakeId =
                this.prizesForm.prizes.length <= 0
                    ? this.prizesForm.prizes.length + 1
                    : Math.max(...this.prizesForm.prizes.map((item) => item.id || item.make_id)) + 1;
            return handleMakeId;
        },

        handleCopyTitle(title) {
            this.prizesForm.prizes.push({
                detail: title.detail,
                image: title.image,
                make_id: this.onHandleMakeId(),
                number_of_winner: title.number_of_winner,
                order_index: title.order_index + 1,
                status: title.status,
                title: `${title.title} Copy ${getCurrentDateTimeFormatted()}`,
                typeAction: 'Edit',
                size_prize: title.size_prize,
                color_prize: title.color_prize,
                background_prize: title.background_prize,
                background_item: title.background_item,
                campaign_event_prize_id: null
            });
            this.handleShotCodeStyle();
        },

        handleEditTitle(title, idx) {
            this.configModalActionTitle.id = title?.id ?? idx;
            this.configModalActionTitle.title = '賞品タイトル編集';
            this.formTitle = {
                ...title,
                size_prize: title.size_prize || '20'
            };
            this.configModalActionTitle.model = true;
        },

        handleDeleteTitle(idx) {
            this.prizesForm.prizes.splice(idx, 1);
            this.handleShotCodeStyle();
        },

        eventAddDataTitle(titleNew) {
            this.prizesForm.prizes.push(titleNew);
            this.handleShotCodeStyle();
        },
        eventUpdateDataTitle(titleNew) {
            const hasConfigId = titleNew?.id ?? titleNew.make_id;
            let indexTitle = this.prizesForm.prizes.findIndex((item) => {
                const hasIdList = item?.id ?? item.make_id;
                return hasIdList == hasConfigId;
            });
            if (indexTitle <= -1) return;
            this.prizesForm.prizes[indexTitle] = titleNew;
            this.handleShotCodeStyle();
        },

        truncateTextTable(text, length) {
            return truncateText(text, length);
        },

        handleShotCodeStyle(type = null) {
            if (!this.prizesForm.style) return;
            let contentNew = [];
            let { contents, backgroundColorDefault } = this.prizesForm.style;
            if (type === 'select') {
                this.prizesForm.background.color = backgroundColorDefault ?? '#ffffff';
            }
            this.prizesForm.prizes.forEach((itemPrize) => {
                const replacements = {
                    タイトル: itemPrize.title ?? '',
                    fontSizePrize: itemPrize.size_prize ? `${itemPrize.size_prize}px` : '46px',
                    colorPrize: itemPrize.color_prize ?? '',
                    bgrColorPrize: itemPrize.background_prize ?? '',
                    詳細: itemPrize.detail ?? '',
                    imgTitle: itemPrize.image?.path ?? '',
                    当選人数: itemPrize.number_of_winner || 0,
                    display: itemPrize?.status ? 'block' : 'none',
                    backgroundItem: itemPrize?.background_item ?? ''
                };
                let contentShotCode = tranferShortCode(contents, replacements);
                contentNew.push(contentShotCode);
            });
            let convertContentString = contentNew.join(``);
            let addProper = this.prizesForm.prizes?.length > 0 ? convertContentString : '';
            this.prizesForm.html_content = addProper;
        }
    },
    watch: {
        infoSettingLandingPage: {
            handler: function (newSetting) {
                if (this.prizesForm.style) return;
                let checkTem = onHandleChangeTemp(newSetting, this.prizesForm, this.listStylePrizes);
                if (checkTem) this.handleShotCodeStyle('select');
            },
            immediate: true,
            deep: true
        },

        dataForm: {
            handler: function (newDataForm) {
                this.prizesForm = newDataForm;
            },
            immediate: true
        },

        prizesForm: {
            handler: function (newPrizesForm) {
                this.$emit('update:dataForm', newPrizesForm);
            },
            immediate: true,
            deep: true
        },

        idxRefreshCampaign: {
            handler: function () {
                this.handleShotCodeStyle();
            },
            deep: true
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.ghost--eventPrize {
    opacity: 0.5;
    background-color: #f8f9fa;
    border: dashed 1px #ccc;
}
</style>
